import script from "./completePage.vue?vue&type=script&setup=true&lang=js"
export * from "./completePage.vue?vue&type=script&setup=true&lang=js"

import "./completePage.vue?vue&type=style&index=0&id=77980f09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77980f09"]])

export default __exports__